module.exports = __webpack_public_path__ + "static/img/Risk240129TW.de52c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk240129TW.jpg
// module id = t8p+
// module chunks = 1